module.exports = __webpack_public_path__ + "static/media/chad.37c8e3f4.jpeg";